<template>
  <FileUpload
    mode="basic"
    name="demo[]"
    :customUpload="true"
    @uploader="myUploader"
    :auto="true"
    accept="text/csv"
    chooseLabel="Import CSV"
    class="template_header_button"
    :style="{ width: '150px' }"
    :disabled="true"
  />
</template>

<script>
import FileUploaderService from "@/services/FileUploaderService";

export default {
  data() {
    return {};
  },
  methods: {
    onUpload() {
      this.$toast.add({ severity: "info", summary: "Success", detail: "File Uploaded", life: 3000 });
    },
    myUploader(event) {
      //console.log("uploader", event.files[0]);

      let reader = new FileReader();

      reader.addEventListener("load", (e) => {
        const data = e.target.result;
        FileUploaderService.getInstance().processData(data);
      });

      reader.readAsText(event.files[0]);
    },
  },
};
</script>

<style scoped></style>
